import { useRef, useState } from "react";
import styled from "styled-components";
import classnames from "classnames";

import { Modal } from "common/components/modal";
import { Placeholder } from "common/components/placeholder";

export const ActionDialog = function({
    show,
    hideModal,
    
    action,
    actionReport,
    childReportId,
    parentSelectedRows,
    createNew,
    handleAction,
    ReportView
}) {
    const formRef = useRef();
    const reportRef = useRef();
    const [loading, setLoading] = useState(false);
    
    const closeDialog = () => {
        setLoading(false);
        hideModal();
    };
    
    if (!show || !action) return null;
    
    const canCreate = action.format === "grid_action" && actionReport.is_editable;
    const dialogTitle = canCreate ? "Pick an existing item or create a new one" : action.action_description;
    
    let actions = [];
    if (action) {
        actions = [{
            text: "Cancel",
            handler: closeDialog,
            classname: "btn-secondary"
        }, {
            text: loading ? <CustomPlaceholder noMargin size="short" /> : action.action_display_name,
            handler: () => {
                setLoading(true);
                
                if (action.format === "grid_action") {
                    handleAction({
                        action,
                        formData: null
                    }).then(closeDialog);
                } else if (["form_action", "combo_action"].includes(action.format)) {
                    handleAction({
                        formData: formRef.current.state.formData,
                        selectedRows: reportRef.current.state.selectedRows,
                        action
                    }).then(closeDialog);
                }
            },
            classname: classnames({ "btn-default": true, disabled: loading })
        }];
        
        if (canCreate) {
            actions.splice(1, 0, {
                text: "Create new",
                handler: createNew
            });
        }
    }
    
    return (
        <Modal
            actions={actions}
            close={closeDialog}
            header={dialogTitle}
            key={`dialog_${action.admin_report_ref}`}
            modal
            portalId="modal-reports-action"
            show={show}
        >
            <ReportWrapper>
                <ReportView
                    id={action.admin_report_ref}
                    ref={reportRef}
                    walk={[]}
                    formRef={formRef}
                    showDetails={false}
                    canCreateNew={false}
                    canExport={false}
                    showRadio
                    showCheckbox={false}
                    parentSelectedAction={action}
                    parentSelectedRows={parentSelectedRows}
                    parentId={childReportId}
                />
            </ReportWrapper>
        </Modal>
    );
};

const ReportWrapper = styled.div`
    min-width: 500px;
    max-width: 60vw;
`;

const CustomPlaceholder = styled(Placeholder)`
    margin: 2px 0;
`;
